module.exports = __webpack_public_path__ + "img/Megan Chun.dd62af9a.jpg";